import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../Controller';

const INVALID_LINK_ROUTE = 'invalid-link';

@Injectable()
export class ActiveApplicationListGuard implements CanActivate {
  controller: Controller;

  constructor(private router: Router, readonly amorphicService: AmorphicService) {
    this.controller = amorphicService.controller as Controller;
  }

  async canActivate(): Promise<boolean> {
    let activeApplications = this.controller.customer.activeApplications;
    activeApplications = activeApplications.filter(
      (app) => !app.isAgentAssistant || (app.isAgentAssistant && app.primaryPolicy.linkSentDate !== null)
    );
    if (activeApplications.length > 0) {
      return true;
    }

    this.router.navigate([INVALID_LINK_ROUTE]);
    return false;
  }
}
